export interface NavigationItem {
    id: string;
    label: string;
    icon: string;
    path?: string;
    matchPath?: string;
    isHeader?: boolean;
    exact?: boolean;
    parent?: string;
}

export interface NavigationArea {
    id: string;
    label: string;
    icon: string;
    items: NavigationItem[];
}

export const normalizeNavigationSearch = (value: string): string =>
    value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase();

export const matchesNavigation = (
    item: NavigationItem,
    pathname: string
): boolean => {
    const path = item.matchPath || item.path;
    if (!path) {
        return false;
    }
    return item.exact || path === "/"
        ? pathname === path
        : pathname === path || pathname.startsWith(`${path}/`);
};

export const buildNavigationAreas = (
    items: NavigationItem[],
    purchasesLabel: string,
    contractingLabel: string
): NavigationArea[] => {
    const areas: NavigationArea[] = [];
    let current: NavigationArea | undefined;
    for (const item of items) {
        if (item.isHeader) {
            current = {
                id: item.id,
                label: item.label,
                icon: item.icon,
                items: [],
            };
            areas.push(current);
        } else if (item.path && current) {
            current.items.push(item);
        }
    }
    const contracting = areas
        .flatMap((area) => area.items)
        .filter((item) => item.id === "clients" || item.id === "tenders");
    const providers = areas
        .flatMap((area) => area.items)
        .filter((item) => item.id === "providers");
    for (const area of areas) {
        area.items = area.items.filter(
            (item) => !["clients", "tenders", "providers"].includes(item.id)
        );
    }
    if (contracting.length) {
        areas.push({
            id: "contracting",
            label: contractingLabel,
            icon: "briefcase",
            items: contracting,
        });
    }
    if (providers.length) {
        areas.push({
            id: "purchases",
            label: purchasesLabel,
            icon: "truck",
            items: providers,
        });
    }
    const order = [
        "header_settings",
        "header_admin",
        "contracting",
        "header_tenders",
        "purchases",
    ];
    const rank = (id: string): number =>
        order.includes(id) ? order.indexOf(id) : order.length;
    return areas
        .filter((area) => area.items.length)
        .sort((a, b) => rank(a.id) - rank(b.id));
};
